import React, { useEffect, useState } from 'react';
import studioLogo from '../Assets/logo-removebg-preview.png';

const SplashScreen = ({ onAnimationComplete }) => {
  const [stage, setStage] = useState('fade-in'); // 'fade-in' | 'reveal' | 'hidden'

  const theme = {
    background: '#F8F6F2',   // Soft Alabaster White base
    accent: '#D4AF37',        // Champagne Gold Accent
    textMain: '#2C302E',      // Charcoal Slate
  };

  useEffect(() => {
    // Stage 1: Logo fades into view and stays for a brief cinematic hold
    const holdTimer = setTimeout(() => {
      setStage('reveal');
    }, 1800);

    // Stage 2: Background mask scales out, and we unmount the screen completely
    const unmountTimer = setTimeout(() => {
      setStage('hidden');
      if (onAnimationComplete) onAnimationComplete();
    }, 2800);

    return () => {
      clearTimeout(holdTimer);
      clearTimeout(unmountTimer);
    };
  }, [onAnimationComplete]);

  if (stage === 'hidden') return null;

  // Custom Keyframe Scripts for Editorial Layer Openings
  const splashAnimations = `
    @keyframes logoGlow {
      0% { opacity: 0; transform: scale(0.96); filter: blur(4px); }
      40% { opacity: 1; transform: scale(1); filter: blur(0); }
      100% { opacity: 0; transform: scale(1.02); filter: blur(2px); }
    }
    @keyframes maskExpand {
      0% { clip-path: inset(0% 0% 0% 0% round 0px); }
      100% { clip-path: inset(50% 50% 50% 50% round 200px); opacity: 0; }
    }
    @keyframes lineTracker {
      0% { width: 0%; opacity: 0; }
      15% { width: 0%; opacity: 1; }
      85% { width: 100%; opacity: 1; }
      100% { width: 100%; opacity: 0; }
    }

    .animate-splash-logo { animation: logoGlow 2s cubic-bezier(0.25, 1, 0.5, 1) forwards; }
    .animate-splash-mask { animation: maskExpand 1s cubic-bezier(0.76, 0, 0.24, 1) forwards; }
    .animate-splash-line { animation: lineTracker 2s cubic-bezier(0.25, 1, 0.5, 1) forwards; }
  `;

  return (
    <div 
      className={stage === 'reveal' ? 'animate-splash-mask' : ''}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: theme.background,
        zIndex: 9999, // Layer rests securely over top navigation elements
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'none',
        boxSizing: 'border-box'
      }}
    >
      <style>{splashAnimations}</style>

      {/* Central Brand Frame Unit */}
      <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
        
        {/* GRAPHIC STUDIO LOGO ACCENT */}
        <img 
          src={studioLogo} 
          alt="ST Interior Studio Logo Branding" 
          className="animate-splash-logo"
          style={{
            height: '90px',
            width: 'auto',
            objectFit: 'contain'
          }}
        />

        {/* Minimal Linear Progress Accelerator Indicator */}
        <div style={{ width: '140px', height: '1px', background: 'rgba(44, 48, 46, 0.06)', position: 'relative', overflow: 'hidden' }}>
          <div 
            className="animate-splash-line"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              background: theme.accent,
              width: '0%'
            }}
          />
        </div>

        {/* Minimal Blueprint Metadata Subtext */}
        <div 
          className="animate-splash-logo"
          style={{
            fontSize: '0.7rem',
            color: theme.textMain,
            letterSpacing: '4px',
            textTransform: 'uppercase',
            fontWeight: '600',
            marginTop: '5px'
          }}
        >
          Evolving Spaces
        </div>

      </div>
    </div>
  );
};

export default SplashScreen;
